//@flow

import {type RecordFactory, type RecordOf, Map, Record} from 'immutable';

import {
  setNormalizedList,
  type RequestResponseMapType,
} from 'app/utils/redux_v2';

import type {RoleType} from './types';
import {type RoleActionType, RECEIVE_ROLE_LIST} from './actions';

type RolesStateShape = RequestResponseMapType<RoleType>;

const RolesStateFactory: RecordFactory<RolesStateShape> = Record({
  byId: Map(),
  queries: Map(),
});

export type RecordOfRolesState = RecordOf<RolesStateShape>;

export const roles = (
  state: RecordOfRolesState = RolesStateFactory(),
  action: RoleActionType
): RecordOfRolesState => {
  switch (action.type) {
    case RECEIVE_ROLE_LIST:
      return setNormalizedList(action.query, action.response, state);
    default:
      return state;
  }
};
